const SERVER = "https://usp-server.netlify.app";
export const APP_BASE_URL = `https://universitynyc.com/`;
export const ADMIN_BASE_URL = `https://usp-admin.netlify.app/`;

export const API_SEND_EMAIL = `${SERVER}/.netlify/functions/server/sendEmail`;
export const API_SEND_NOTIFICATION = `${SERVER}/.netlify/functions/server/sendNotification`;
export const API_SEND_NOTIFICATION_TO_EMAIL = `${SERVER}/.netlify/functions/server/sendNotificationToEmail`;
export const API_SET_FCM_TOKEN = `${SERVER}/.netlify/functions/server/setFcmToken`;
